import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import MenuBar from "../MenuBar";
import { Row, Col, Panel, Button } from "react-bootstrap";
import { getDisciplinesList } from "../../_actions";
import NoteIcon from "../../_icons/NoteIcon";
import AlertIcon from "../../_icons/AlertIcon";
import ReportIcon from "../../_icons/ReportIcon";
import DeviceIcon from "../../_icons/DeviceIcon";
import NoteSmallIcon from "../../_icons/NoteSmallIcon";
import _ from "lodash";
import "./index.css";

class DashboardNoPermission extends Component {
  constructor(props) {
    super(props);
    this.backgroundId = this.getRandomInt(1, 6);
  }
  getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  renderBackgroundClass = () => {
    return "bg-" + this.backgroundId;
  };

  renderLeftPanel = () => {
    return (
      <Col xs={12} md={6}>
        <div className="dashboard-desc">
          Welcome to your Metro Tunnel Environmental Monitor. This innovative platform collates and aggregates data
          from a wide variety of sensors across the project and performs real time data analysis to enable compliance
          with environmental regulations via stakeholder notifications and audit records.
        </div>
      </Col>
    );
  };

  renderAlertCard = title => {
    const route = "/" + title.toLowerCase();
    return (
      <Col xs={12} md={3}>
        <Panel className="panel-length">
          <div className="panel-title">
            <AlertIcon fill="#000000" className="icon" />
            {title}
          </div>
          <div className="panel-body">
            Alerts are sensor events which have triggered warning or EPR levels. You can view a list of logged alerts,
            or look at the detail of a specific one.
          </div>
          <div className="panel-foot">
            <Link className="btn btn-primary" to={route}>
              View {title}
            </Link>
          </div>
        </Panel>
      </Col>
    );
  };

  renderNoteCard = (title, notePermission) => {
    if (!notePermission) {
      return null;
    }
    const route = "/" + title.toLowerCase();
    return (
      <Col xs={12} md={3}>
        <Panel className="panel-length">
          <div className="panel-title">
            <NoteIcon fill="#000000" className="icon" />
            {title}
          </div>
          <div className="panel-body">
            Notes are used to meet the project&#39;s reporting obligations. When an alert or event requires additional
            investigation, observations and comments are logged in a note. You can view these notes here.
          </div>
          <div className="panel-foot">
            <Link className="btn btn-primary" to={route}>
              View {title}
            </Link>
          </div>
        </Panel>
      </Col>
    );
  };

  renderReportCard = title => {
    if (
      !this.props.configList ||
      this.props.configList.permissions.reports === undefined ||
      this.props.configList.permissions.reports === null ||
      this.props.configList.permissions.reports.length < 1
    ) {
      return null;
    }

    let reportViewCheck;
    if (
      _.find(this.props.configList.permissions.reports, item => {
        return item.can_view_reports === true;
      })
    ) {
      reportViewCheck = true;
    } else {
      reportViewCheck = false;
    }

    if (!reportViewCheck) {
      return null;
    }

    const route = "/" + title.toLowerCase();
    return (
      <Col xs={12} md={3}>
        <Panel className="panel-length">
          <div className="panel-title">
            <ReportIcon fill="#000000" className="icon" />
            {title}
          </div>
          <div className="panel-body">
            Reports capture sensor data, along with any relevant alerts or notes and presents them in a format that can
            be shared with key stakeholders. You can view available reports here.
          </div>
          <div className="panel-foot">
            <Link className="btn btn-primary" to={route}>
              View {title}
            </Link>
          </div>
        </Panel>
      </Col>
    );
  };

  renderDeviceCard = title => {
    const route = "/devicesMap";
    return (
      <Col xs={12} md={3}>
        <Panel className="panel-length">
          <div className="panel-title">
            <DeviceIcon fill="#000000" className="icon" />
            {title}
          </div>
          <div className="panel-body">
            Sensor data is available to view as it arrives in real time. You can view a list or map of the available
            sensors, look at live or historical data and download data to view in a spreadsheet.
          </div>
          <div className="panel-foot">
            <Link className="btn btn-primary" to={route}>
              View {title}
            </Link>
          </div>
        </Panel>
      </Col>
    );
  };

  renderObervationButton = () => {
    const { configList } = this.props;

    if (!configList.permissions.observations || configList.permissions.observations.length < 1) {
      return null;
    }

    return (
      <Row className="show-grid observation-button-panel">
        <Col xs={12}>
          <Link to={"/createObservation"}>
            <Button bsStyle="primary" className="btn-observation pull-right">
              <NoteSmallIcon className="small-icon" stroke="#ffffff" />Log an observation
            </Button>
          </Link>
        </Col>
      </Row>
    );
  };

  render() {
    const { notePermission, configList } = this.props;

    if (!configList) {
      return null;
    }

    return (
      <div className={" dashboardNoPermission " + this.renderBackgroundClass()}>
        <div className="dashboard-page-overlay">
          <MenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderObervationButton()}
              <Row className="show-grid title-panel">
                <Col xs={12} md={12}>
                  <div className="dashboard-title">Metro Tunnel Environmental Monitor</div>
                </Col>
              </Row>
              <Row className="desc-panel">{this.renderLeftPanel()}</Row>
            </div>
          </div>
          <div className="dashboard-btm">
            <div className="container">
              <Row className="card-panel row-eq-height">
                {this.renderAlertCard("Alerts")}
                {this.renderNoteCard("Notes", notePermission)}
                {this.renderReportCard("Reports")}
                {this.renderDeviceCard("Devices")}
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { notePermission } = state.note;
  const { configList } = state.configuration;
  return {
    notePermission,
    configList
  };
}

export default connect(
  mapStateToProps,
  { getDisciplinesList }
)(DashboardNoPermission);



// WEBPACK FOOTER //
// ./src/_components/DashboardNoPermission/index.js